import React from "react";

import styles from "../../../../styles/integrations.module.scss";

import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { Loading } from "../../../components/Loading";
import { Drawer } from "../../../components/Drawer";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { Context } from "pages/Integrations";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import { IntegrationsAPI } from "providers/IntegrationsAPI";
import BlingStatusesDrawer from "./BlingStatusesDrawer";
import BlingPaymentDrawer from "./BlingPaymentDrawer";
import BlingSellerDrawer from "./BlingSellerDrawer";
import BlingFinanceCategoryDrawer from "./BlingFinanceCategoryDrawer";

export default class BlingAppDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loading: false,
      step: null,
      account: null,
    };

    this.timer = null;
    this.window = null;
    this.listener = null;
    this.windowChecker = null;
  }

  componentDidMount() {
    this.loadConfigs();

    this.windowChecker = setInterval(() => {
      if (this.window && this.window.closed) {
        this.closeAuthorization();
      }
    }, 1000);

    const onConfirmed = async (event) => {
      if (event.data.type === "OAUTH_CODE") {
        const { code } = event.data || {};
        const confirmed = await this.confirmAuthorization({ code });
        if (confirmed) {
          await this.loadConfigs();
        }

        this.closeAuthorization();
      }
    };

    window.addEventListener("message", onConfirmed);
    this.listener = onConfirmed;
  }

  componentWillUnmount() {
    this.timer && clearTimeout(this.timer);
    this.window && this.window.close();
    this.listener && window.removeEventListener("message", this.listener);
    this.windowChecker && clearInterval(this.windowChecker);
  }

  async loadConfigs() {
    try {
      const environmentId = EnvironmentStorage.getEnvironment().id;

      const accountResponse = await IntegrationsAPI.getBlingAccount(
        environmentId
      );

      const account = await accountResponse.getData();

      const initialStep = account ? "ACCOUNT" : "APP";

      this.setState({
        loadingPage: false,
        account: account || null,
        step: initialStep,
      });
    } catch (err) {
      console.log(err);
    }
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const { active, storeId } = this.state;

      this.setState({ loading: true });

      const environmentId = EnvironmentStorage.getEnvironment().id;

      const externalCredentials =
        await EnvironmentsAPI.getConfigurationsByAlias(
          environmentId,
          "external_credentials"
        );
      const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
        environmentId,
        "external_credentials",
        {
          ...externalCredentials,
          bling: {
            active,
            storeId,
          },
        }
      );

      this.setState({ loading: false });

      if (updateResponse.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível alterar a configuração: ${
            updateResponse.getErrors()[0]
          }`,
        });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  openAuthorizationWindow({ url }) {
    const width = 600;
    const height = 600;

    const screenLeft =
      window.screenLeft !== undefined ? window.screenLeft : window.screen.left;
    const screenTop =
      window.screenTop !== undefined ? window.screenTop : window.screen.top;

    const screenWidth = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : window.screen.width;

    const screenHeight = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : window.screen.height;

    // Calcula posição
    const left = screenLeft + (screenWidth - width) / 2;
    const top = screenTop + (screenHeight - height) / 2;

    // Abre a janela centralizada
    const loginWindow = window.open(
      url,
      "LoginWindow",
      `width=${width},height=${height},top=${top},left=${left}`
    );

    return loginWindow;
  }

  async requestAuthorization() {
    const { clientId } = this.state;
    const state = Math.random().toString(36).substring(2);

    this.setState({ loading: true });

    const url = `https://www.bling.com.br/Api/v3/oauth/authorize?response_type=code&client_id=${clientId}&state=${state}`;

    this.window = this.openAuthorizationWindow({ url });

    this.timer = setTimeout(() => {
      alert({
        text: "Tempo esgotado! Tente realizar o vinculo da conta novamente.",
      });

      this.closeAuthorization();
    }, 1000 * 60);
  }

  closeAuthorization() {
    console.log("Solicitando fechamento da janela de autorização");

    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }

    if (this.window) {
      this.window.close();
      this.window = null;
    }

    this.setState({ loading: false });
  }

  async confirmAuthorization({ code }) {
    const { clientId, clientSecret } = this.state;

    const environmentId = EnvironmentStorage.getEnvironment().id;

    const linkResponse = await IntegrationsAPI.linkBlingAccount({
      environmentId,
      code,
      clientId,
      clientSecret,
    });

    if (linkResponse.getErrors([]).length > 0) {
      alert({
        text: linkResponse.getErrors()[0],
      });

      return false;
    }

    return true;
  }

  isValid() {
    const { step } = this.state;

    if (step === "APP") {
      const { clientId, clientSecret } = this.state;
      return clientId && clientSecret;
    }

    return true;
  }

  render() {
    const { loading, loadingPage, step, account, clientId, clientSecret } =
      this.state;
    const { visible, onClose } = this.props;

    const isValid = clientId && clientSecret;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title={"Bling - Aplicativo"}
        footer={
          step === "APP" && (
            <Button
              design="primary"
              className="w-100"
              onClick={() => this.requestAuthorization()}
              loading={loading}
              disabled={loading || !this.isValid()}
            >
              Vincular conta
            </Button>
          )
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            {step === "APP" && (
              <>
                <Input
                  design="two"
                  className="mb-20"
                  floatLabel="Client ID"
                  value={clientId}
                  onChange={(e) => this.setState({ clientId: e.target.value })}
                />

                <Input
                  design="two"
                  className="mb-20"
                  floatLabel="Client Secret"
                  value={clientSecret}
                  onChange={(e) =>
                    this.setState({ clientSecret: e.target.value })
                  }
                />
              </>
            )}

            {step === "ACCOUNT" && (
              <>
                <Input
                  design="two"
                  className="mb-20"
                  floatLabel="Código da Conta"
                  value={account?.id}
                  disabled
                />

                <Input
                  design="two"
                  className="mb-20"
                  floatLabel="Nome da Conta"
                  value={account?.name}
                  disabled
                />

                <Input
                  design="two"
                  className="mb-20"
                  floatLabel="E-mail da Conta"
                  value={account?.email}
                  disabled
                />

                <Button
                  design="primary"
                  className="w-100 mb-10"
                  onClick={() => this.setState({ step: "STATUS" })}
                >
                  Configurar situações
                </Button>

                <Button
                  design="primary"
                  className="w-100 mb-10"
                  onClick={() => this.setState({ step: "SELLER" })}
                >
                  Configurar vendedor
                </Button>

                <Button
                  design="primary"
                  className="w-100 mb-10"
                  onClick={() => this.setState({ step: "FINANCE_CATEGORY" })}
                >
                  Configurar categoria
                </Button>

                <Button
                  design="primary"
                  className="w-100 mb-10"
                  onClick={() => this.setState({ step: "PAYMENT_METHOD" })}
                >
                  Configurar formas de pagamento
                </Button>
              </>
            )}

            {step === "STATUS" && (
              <BlingStatusesDrawer
                visible={true}
                onClose={() => this.setState({ step: "ACCOUNT" })}
              />
            )}

            {step === "PAYMENT_METHOD" && (
              <BlingPaymentDrawer
                visible={true}
                onClose={() => this.setState({ step: "ACCOUNT" })}
              />
            )}

            {step === "SELLER" && (
              <BlingSellerDrawer
                visible={true}
                onClose={() => this.setState({ step: "ACCOUNT" })}
              />
            )}

            {step === "FINANCE_CATEGORY" && (
              <BlingFinanceCategoryDrawer
                visible={true}
                onClose={() => this.setState({ step: "ACCOUNT" })}
              />
            )}

          </div>
        )}
      </Drawer>
    );
  }
}
